import { render } from "./LeftSidebar.vue?vue&type=template&id=f817f97e&scoped=true"
import script from "./LeftSidebar.vue?vue&type=script&lang=js"
export * from "./LeftSidebar.vue?vue&type=script&lang=js"

import "./LeftSidebar.vue?vue&type=style&index=0&id=f817f97e&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f817f97e"]])

export default __exports__